import { z } from 'zod';
/** Нутриенты всегда хранятся и передаются в расчёте на 100 г / 100 мл. */
export const nutrientsSchema = z.object({
    kcal: z.number().min(0).max(1000),
    protein: z.number().min(0).max(100),
    fat: z.number().min(0).max(100),
    carbs: z.number().min(0).max(100),
    fiber: z.number().min(0).max(100).nullable().default(null),
    sugars: z.number().min(0).max(100).nullable().default(null),
    salt: z.number().min(0).max(100).nullable().default(null),
});
export const SEX = ['male', 'female'];
export const sexSchema = z.enum(SEX);
/** Коэффициенты активности для формулы Миффлина - Сан Жеора. */
export const ACTIVITY_LEVELS = {
    sedentary: 1.2,
    light: 1.375,
    moderate: 1.55,
    high: 1.725,
    athlete: 1.9,
};
export const activityLevelSchema = z.enum(Object.keys(ACTIVITY_LEVELS));
/** Поправка к суточной норме: похудение −20 %, набор +15 %. */
export const GOAL_TYPES = {
    lose: -0.20,
    maintain: 0,
    gain: 0.15,
};
/**
 * Ниже этих значений норму не опускаем.
 *
 * Формула ничего не знает о безопасности: женщина 55 лет ростом 155 см и весом
 * 52 кг при сидячем образе жизни получала 1011 ккал в день. Такие цифры вредны
 * и без наблюдения врача их ставить нельзя.
 */
export const MIN_DAILY_KCAL = {
    female: 1200,
    male: 1500,
};
export const goalTypeSchema = z.enum(Object.keys(GOAL_TYPES));
export const MEAL_TYPES = ['breakfast', 'lunch', 'dinner', 'snack'];
export const mealTypeSchema = z.enum(MEAL_TYPES);
/**
 * Приём пищи по часу суток.
 *
 * Живёт в общем пакете, чтобы клиент и сервер не разошлись в границах:
 * сервер решает по часовому поясу пользователя, клиент - для подсказок.
 */
export function mealByHour(hour) {
    if (hour < 11)
        return 'breakfast';
    if (hour < 16)
        return 'lunch';
    if (hour < 22)
        return 'dinner';
    return 'snack';
}
//# sourceMappingURL=nutrition.js.map